import { useEffect } from 'react';
import { EDITOR_MODE } from './sceneEditor';

export function EventManager({
  setEditorMode,
  onDeleteModel,
  selectedModel,
  selectableAssets,
  setSelectedModel,
}) {
  const handleKeyUp = (e) => {
    switch (e.code) {
      case 'KeyQ':
        setEditorMode(EDITOR_MODE.TRANSLATE);
        break;
      case 'KeyE':
        setEditorMode(EDITOR_MODE.SCALE);
        break;
      case 'KeyR':
        setEditorMode(EDITOR_MODE.ROTATE);
        break;
      case 'Delete':
        onDeleteModel();
        break;
      case 'Escape':
        setSelectedModel(undefined);
        break;
    }
  };

  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp);
    return () => {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [selectedModel, selectableAssets]);

  return null;
}
